import "antd/es/table/style";
import _Table from "antd/es/table";
var _excluded = ["value", "$sui"],
    _excluded2 = ["defaultValue", "id", "labelId", "columns", "componentStyle", "help"],
    _excluded3 = ["editable", "type"];

var _class;

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  Object.defineProperty(subClass, "prototype", {
    value: Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    }),
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import { $attrs } from "../sui/bind";
import classnames from "classnames";
import { toJS } from 'mobx';
import Input from "../sui-input";
import Cascader from '../sui-cascader';
import Checkbox from '../sui-checkbox';
import Datepicker from '../sui-date-picker';
import Daterange from '../sui-date-range';
import Group from '../sui-group';
import Number from '../sui-number';
import Radio from '../sui-radio';
import Rate from '../sui-rate';
import Switch from '../sui-switch';
import Select from '../sui-select';
import Slider from '../sui-slider';
import Timepicker from '../sui-time-picker';
import Treeselect from '../sui-tree-select';
import createFormComponent from '../sui/createFormComponent';
/**
 * 数据表格控件
 */

var SuiDataTable = createFormComponent(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(SuiDataTable, _React$Component);

  var _super = _createSuper(SuiDataTable);

  function SuiDataTable(props, context) {
    var _this;

    _classCallCheck(this, SuiDataTable);

    _this = _super.call(this, props, context);
    _this.defaultValue = undefined;

    _this.getRefDOM = function (node) {
      if (node && _this.refDOM !== node) {
        _this.refDOM = node;
      }

      return _this.refDOM;
    };

    _this.getRefInstance = function (node) {
      if (node && _this.refInstance !== node) {
        _this.refInstance = node;
      }

      return _this.refInstance;
    };

    var defaultValue = props.defaultValue;
    _this.attrs = $attrs({
      value: defaultValue,
      readOnly: false,
      disabled: false
    });

    _this.attrs.$sui.attach(props, _assertThisInitialized(_this), context);

    _this.verify("init");

    return _this;
  } // onChange修改value值


  _createClass(SuiDataTable, [{
    key: "changeValue",
    value: function changeValue(val, record, row, dataIndex, type, value) {
      if (record) {
        record[dataIndex] = value;
      }

      this.attrs.value = val;

      if (this.props.onChange) {
        this.props.onChange.call(this, val, record, row, dataIndex, type, value);
      } // this.verify("change");

    } //子组件change

  }, {
    key: "childchange",
    value: function childchange(record, row, dataIndex, type, val, val2) {
      var value = val;

      if (/datepicker|daterange|timepicker|checkbox|radio|switch/i.test(type)) {
        value = val2;
      }

      var newdata = toJS(this.attrs.value);

      if (newdata && newdata[row]) {
        newdata[row][dataIndex] = value;
      }

      this.changeValue(newdata, record, row, dataIndex, type, value);
    } // 获取组件容器DOM

  }, {
    key: "doRender",
    value: function doRender() {
      var _this2 = this;

      console.log(" ==== render dataTable ==== ", this.attrs.value);

      var _this$attrs = this.attrs,
          value = _this$attrs.value,
          $sui = _this$attrs.$sui,
          attrs = _objectWithoutProperties(_this$attrs, _excluded);

      var _$sui$restProps = $sui.restProps,
          defaultValue = _$sui$restProps.defaultValue,
          _$sui$restProps$id = _$sui$restProps.id,
          id = _$sui$restProps$id === void 0 ? this.uuid : _$sui$restProps$id,
          labelId = _$sui$restProps.labelId,
          _$sui$restProps$colum = _$sui$restProps.columns,
          columns = _$sui$restProps$colum === void 0 ? [] : _$sui$restProps$colum,
          componentStyle = _$sui$restProps.componentStyle,
          help = _$sui$restProps.help,
          props = _objectWithoutProperties(_$sui$restProps, _excluded2);

      columns = columns.map(function (item) {
        if (item.edit && item.edit.editable !== false) {
          var _item$edit = item.edit,
              editable = _item$edit.editable,
              type = _item$edit.type,
              childProps = _objectWithoutProperties(_item$edit, _excluded3);

          if (!item.render) {
            item.render = function (val, record, row) {
              var child;

              switch (type) {
                case "Input":
                  child = /*#__PURE__*/React.createElement(Input, _extends({}, childProps, {
                    value: val,
                    onChange: _this2.childchange.bind(_this2, record, row, item.dataIndex, type)
                  }));
                  break;

                case "Cascader":
                  child = /*#__PURE__*/React.createElement(Cascader, _extends({}, childProps, {
                    value: val,
                    onChange: _this2.childchange.bind(_this2, record, row, item.dataIndex, type)
                  }));
                  break;

                case "Datepicker":
                  child = /*#__PURE__*/React.createElement(Datepicker, _extends({}, childProps, {
                    value: val,
                    onChange: _this2.childchange.bind(_this2, record, row, item.dataIndex, type)
                  }));
                  break;

                case "Checkbox":
                  child = /*#__PURE__*/React.createElement(Checkbox, _extends({}, childProps, {
                    value: val,
                    onChange: _this2.childchange.bind(_this2, record, row, item.dataIndex, type)
                  }));
                  break;

                case "Daterange":
                  child = /*#__PURE__*/React.createElement(Daterange, _extends({}, childProps, {
                    value: val,
                    onChange: _this2.childchange.bind(_this2, record, row, item.dataIndex, type)
                  }));
                  break;

                case "Group":
                  child = /*#__PURE__*/React.createElement(Group, _extends({}, childProps, {
                    value: val,
                    onChange: _this2.childchange.bind(_this2, record, row, item.dataIndex, type)
                  }));
                  break;

                case "Number":
                  child = /*#__PURE__*/React.createElement(Number, _extends({}, childProps, {
                    value: val,
                    onChange: _this2.childchange.bind(_this2, record, row, item.dataIndex, type)
                  }));
                  break;

                case "Radio":
                  child = /*#__PURE__*/React.createElement(Radio, _extends({}, childProps, {
                    value: val,
                    onChange: _this2.childchange.bind(_this2, record, row, item.dataIndex, type)
                  }));
                  break;

                case "Rate":
                  child = /*#__PURE__*/React.createElement(Rate, _extends({}, childProps, {
                    value: val,
                    onChange: _this2.childchange.bind(_this2, record, row, item.dataIndex, type)
                  }));
                  break;

                case "Select":
                  child = /*#__PURE__*/React.createElement(Select, _extends({}, childProps, {
                    value: val,
                    onChange: _this2.childchange.bind(_this2, record, row, item.dataIndex, type)
                  }));
                  break;

                case "Slider":
                  child = /*#__PURE__*/React.createElement(Slider, _extends({}, childProps, {
                    value: val,
                    onChange: _this2.childchange.bind(_this2, record, row, item.dataIndex, type)
                  }));
                  break;

                case "Timepicker":
                  child = /*#__PURE__*/React.createElement(Timepicker, _extends({}, childProps, {
                    value: val,
                    onChange: _this2.childchange.bind(_this2, record, row, item.dataIndex, type)
                  }));
                  break;

                case "Treeselect":
                  child = /*#__PURE__*/React.createElement(Treeselect, _extends({}, childProps, {
                    value: val,
                    onChange: _this2.childchange.bind(_this2, record, row, item.dataIndex, type)
                  }));
                  break;

                case "Switch":
                  child = /*#__PURE__*/React.createElement(Switch, _extends({}, childProps, {
                    value: val,
                    onChange: _this2.childchange.bind(_this2, record, row, item.dataIndex, type)
                  }));
                  break;

                default:
                  child = /*#__PURE__*/React.createElement("span", null, val);
                  break;
              }

              return child;
            };
          }
        }

        return item;
      });
      var classNames = classnames("sui-component sui-datatable");

      if (value && typeof value === 'string') {
        try {
          value = JSON.parse(value);
        } catch (error) {}
      }

      var val = toJS(_typeof(value) === 'object' ? value : []);
      return /*#__PURE__*/React.createElement("div", {
        style: componentStyle,
        id: id,
        ref: this.getRefDOM,
        className: classNames
      }, /*#__PURE__*/React.createElement(_Table, _extends({
        id: labelId
      }, props, attrs, {
        ref: this.getRefInstance,
        dataSource: val,
        columns: columns
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return this.doRender();
    }
  }]);

  return SuiDataTable;
}(React.Component)) || _class;

export default SuiDataTable;